<div id="wrapper">
    <div class="container-fluid">

    <div class="row">
        <div class="col-lg-4 col-md-4 mx-auto my-card">
                <mat-progress-bar mode="indeterminate" *ngIf="flag === true"></mat-progress-bar>
            <div class="text-center" id="resp"></div><br />
          <p><small>To reset your password, enter your email below, click the link sent to your email and proceed to change your password.</small></p>
          <form [formGroup]="forgotPasscodeForm" (ngSubmit)="forgotPasscode(forgotPasscodeForm)">
              <mat-form-field>
                  <mat-placeholder>
                      <mat-icon>mail</mat-icon>  Email
                  </mat-placeholder>
                <input matInput type="email" formControlName="email" id="email">
              </mat-form-field>
              <span class="aler" *ngIf="!forgotPasscodeForm.controls['email'].valid &&
                        forgotPasscodeForm.controls['email'].touched"><small>*Required</small></span>
              <button type="submit" mat-raised-button id="send" style="outline:none;"
               class="btn-block d-block mx-auto" color="primary" [disabled]="!forgotPasscodeForm.valid">
                <span>Send</span>
              </button>
          </form>
          <a routerLink="/login">Login</a>
        </div>
      </div>
    </div>
    </div>